module.exports = __webpack_public_path__ + "img/green-3-oval-striped.339f040f.svg";